<template>

    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="项目评审名称" name="projectReviewName">
                <a-input v-model:value="searchForm.projectReviewName" placeholder="请输入项目评审名称"/>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                新增
            </a-button>
        </div>

        <a-table :columns="columns"
                 :pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
            <template #projectReviewName="{ record,text }">
              <a @click="showDetail(record)" href="javascript:;" :title="text" >{{ text }}</a>
            </template>
            <template #meetingMinutes="{ record }">
                <FileUpload v-model:value="record.meetingMinutes" :show-btn="false" disabled></FileUpload>
            </template>
            <template #applicationAttachment="{ record }">
                <FileUpload v-model:value="record.applicationAttachment" :show-btn="false" disabled></FileUpload>
            </template>
            <template #reviewStatus="{ record,text }">
                <a-tag v-if="text==='1'" style="color: #03bbd4; border-color: #03bbd4">未提交</a-tag>
                <a-tag v-if="text==='2'" style="color: #bb6bd0; border-color: #bb6bd0">待审核</a-tag>
                <a-tag v-if="text==='3'" style="color: #FFC018; border-color: #FFC018">已审核</a-tag>
                <a-tag v-if="text==='4'" style="color: #FF0000; border-color: #FF0000">未通过</a-tag>
                <a-tooltip>
                    <template #title>{{ record.auditDenyReason }}</template>
                    <svg v-if="text==='4'" style="cursor:pointer; color: #FF0000;vertical-align: middle;width: 18px; height: 18px" focusable="false" class="" data-icon="question-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true" viewBox="64 64 896 896"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"></path><path d="M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z"></path></svg>
                </a-tooltip>
            </template>
            <template #action="{ record }">
                <div class="table-row-operations" v-if="record.reviewStatus==='1' || record.reviewStatus==='4'">
                    <a @click="onEdit(record)">编辑</a>
                    <a-popconfirm
                        title="确定要提交吗? 提交后无法修改或删除!"
                        ok-text="是"
                        cancel-text="否"
                        @confirm="onSubmit(record)"
                        @cancel="()=>{}"
                    >
                        <a>提交</a>
                    </a-popconfirm>
                    <a-popconfirm
                        title="确定要删除吗?"
                        ok-text="是"
                        cancel-text="否"
                        @confirm="onDelete(record.id)"
                        @cancel="()=>{}"
                    >
                        <a>删除</a>
                    </a-popconfirm>
                </div>
            </template>
        </a-table>
    </a-card>
    <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
    <detail ref="detail"></detail>
</template>

<script>

import {dictMixin, tableListMixin} from "@/mixins";

import {application} from "@/api/projectReviewService";
import AddOrEditModal from "./components/AddOrEditModal";
import FileUpload from "@/components/form/upload/FileUpload";
import Detail from "./components/Detail";


const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
    {
        title: "评审名称",
        dataIndex: "projectReviewName",
        key: "projectReviewName",
        slots: {customRender: "projectReviewName"}
    },
    // {title: "评审概述", ellipsis: true, dataIndex: "projectOverview", key: "projectOverview"},
    {title: "审核状态", width: "120px",dataIndex: "reviewStatus", key: "reviewStatus", slots: {customRender: "reviewStatus"}},
    {title: "计划评审时间", width: "118px", dataIndex: "reviewPlanTime", key: "reviewPlanTime"},
    // {title: "会议纪要", ellipsis: true, dataIndex: "meetingMinutes", key: "meetingMinutes", slots: {customRender: "meetingMinutes"}},
    // {
    //     title: "评审内容",
    //     ellipsis: true,
    //     dataIndex: "applicationAttachment",
    //     key: "applicationAttachment",
    //     slots: {customRender: "applicationAttachment"}
    // },
    {title: "操作", width: "180px",ellipsis: true, dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "index",
    mixins: [tableListMixin, dictMixin],
    components: {
      Detail,
        FileUpload,
        AddOrEditModal,

    },
    data() {
        return {
            columns,
            queryParamFixed:{reviewStatus: '1,2,3,4'},
            queryParam: {},
            listUrl: application.myPageList,
            listKeyField: "id",
            deleteUrl: application.delete
        }
    },
    methods: {
        truncateText(text, maxLength) {
            // 定义一个最大字符数限制
            if (text && text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            }
            return text;
        },
        showDetail(row){
          let rows = {...row}
          this.onShowModal("detail", rows)
        },
        onAdd() {
            this.onShowModal('modal');
        },
        onEdit(record) {
            this.getAction({
                url: application.detail,
                params: {id: record.id}
            }).then(res => {
                this.onShowModal('modal', res);
            })
        },
        onSubmit(record) {
            this.postAction({
                url: application.submit,
                params: {id: record.id}
            }).then(() => {
                this.loadData(this.pagination.current)
            })
        },

    }
}
</script>

<style scoped>

</style>
